export default "__VITE_ASSET__Ddx1CffK__"